/* Import Libs */

import 'intersection-observer';
import '../../modules/system/assets/js/framework';
import './js/inputmask';
import './js/validation';
import './js/utils';
import './js/lazy-load';
// import './js/select2';
// import './js/pusher';
import './js/preloader';
import '../../node_modules/focus-visible/dist/focus-visible';
import './js/waiting';

/* * Header * */
import './partials/header/userbar/userbar';
import './partials/header/header-nav';
import './partials/header/header-call';
import './partials/header/header-phones';

/* * Drawer * */
import './partials/header/drawer-nav/drawer-nav';
import './partials/header/search/search';
import './partials/product/cart/cart-mini/cart-mini';
import './partials/product/wish-list/wish-list';

/* * Form * */

import './partials/form/input/input';
import './partials/form/input/textarea';
// import './partials/form/select2/select';

/* * Other * */

import './partials/product/cart/cart-product/cart-product';
import './partials/product/wish-list/wish-product/wish-product';
import './partials/common/wysiwyg/wysiwyg';
import './partials/common/evermodal/evermodal-dialog';

import './partials/common/account/account';
// import './partials/form/button/button-add-to-cart';
// import './partials/common/buy/buy-add-to-cart';
import './partials/common/buy/add-to-cart';
import './partials/common/buy/buy-drawer';
import './partials/common/buy/buy-counter';
import './partials/product/product-buy/button-block';

import './partials/common/pagination/showmore';
import './partials/content/products-sample/products-sample';
import './pages/account';
import './partials/content/crud-items/crud-items';

$(window).scroll(() => {
  const scroll = $(window).scrollTop();

  if (scroll >= 60) {
    $('body').addClass('fixed-nav');
  } else {
    $('body').removeClass('fixed-nav');
  }
});

document.addEventListener('keydown', (event) => {
  const e = event || window.event;
  if ((e.which || e.keyCode) === 13) {
    const elem = document.querySelector('.bind_enter');
    const eventClick = new Event('click');
    elem.dispatchEvent(eventClick);
  }
});
